const safety_values = {
}

export default safety_values
